"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsPropertyCard = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var SearchHighlight_1 = require("../../shared/components/SearchHighlight");
var demo_auth_context_1 = require("../../shared/auth/demo-auth-context");
var use_metrics_property_management_1 = require("../hooks/use-metrics-property-management");
var MetricsUseCaseCallout_1 = require("./MetricsUseCaseCallout");
var element_popup_service_1 = require("../../shared/components/EntityPopup/services/element-popup.service");
/**
 * Single signal card in the right panel. Owns the local pill ref used
 * to anchor the use-case callout but delegates open/close state to the
 * parent so only one callout is open at a time across the panel.
 *
 * The card also exposes a per-row expand chevron when the canonical
 * element has merged surface variants (`aliases`). Expanding reveals
 * an inline accordion listing every alias the extraction matcher
 * folded into this canonical row — useful when reviewing whether the
 * cascade (EXACT / FUZZY / EMBEDDING) merged things sensibly.
 */
exports.MetricsPropertyCard = function (_a) {
    var _b, _c;
    var elementType = _a.elementType, property = _a.property, isSelected = _a.isSelected, isChanged = _a.isChanged, ownerOptions = _a.ownerOptions, selectedOwnerIds = _a.selectedOwnerIds, canEditOwner = _a.canEditOwner, searchMatcher = _a.searchMatcher, openUseCasesPropertyId = _a.openUseCasesPropertyId, stagedOwnerIds = _a.stagedOwnerIds, stagedStatus = _a.stagedStatus, onToggleSelection = _a.onToggleSelection, onToggleUseCases = _a.onToggleUseCases, onDismissUseCases = _a.onDismissUseCases, onOpenUseCase = _a.onOpenUseCase, onStageManagement = _a.onStageManagement;
    var activeUser = demo_auth_context_1.useDemoAuth().activeUser;
    var pillRef = react_1.useRef(null);
    var _d = react_1.useState(false), isExpanded = _d[0], setIsExpanded = _d[1];
    var _e = react_1.useState(false), isOwnerManagementOpen = _e[0], setIsOwnerManagementOpen = _e[1];
    var propertyUseCases = Array.isArray(property.useCases) ? property.useCases : [];
    var useCaseCount = propertyUseCases.length;
    var isCalloutOpen = openUseCasesPropertyId === property.id;
    // Normalize defensively: a stale draft (or an older backend
    // response) may still have aliases as plain strings instead of
    // `{ text, useCases }`, and per-alias `useCases` as bare id
    // strings instead of `{ id, title }`. Handle every shape so this
    // card never crashes mid-render after a hot-reload or cache miss.
    var aliases = ((_b = property.aliases) !== null && _b !== void 0 ? _b : []).map(function (alias) {
        var _a;
        if (typeof alias === 'string') {
            return { text: alias, useCases: [] };
        }
        var rawList = Array.isArray(alias.useCases) ? alias.useCases : [];
        var useCases = rawList
            .map(function (raw) {
            if (typeof raw === 'string') {
                return { id: raw, title: raw };
            }
            if (raw && typeof raw === 'object') {
                var obj = raw;
                var id = typeof obj.id === 'string' ? obj.id : '';
                if (!id) {
                    return null;
                }
                var title = typeof obj.title === 'string' && obj.title.length > 0 ? obj.title : id;
                return { id: id, title: title };
            }
            return null;
        })
            .filter(function (ref) { return ref !== null; });
        return {
            text: (_a = alias.text) !== null && _a !== void 0 ? _a : '',
            useCases: useCases,
        };
    });
    var aliasCount = aliases.length;
    var canExpand = aliasCount > 0;
    var shouldShowStatusField = elementType === 'data' || elementType === 'tech';
    var canEditStatus = activeUser.role === 'admin' ||
        activeUser.role === 'group-owner' || activeUser.role === 'owner';
    var initialStatus = property.isReady === true
        ? use_metrics_property_management_1.METRICS_STATUS_OPTIONS[1]
        : use_metrics_property_management_1.METRICS_STATUS_OPTIONS[0];
    var _f = react_1.useState((_c = property.isEnabled) !== null && _c !== void 0 ? _c : true), isElementActive = _f[0], setIsElementActive = _f[1];
    var _g = react_1.useState(false), isTogglingElementState = _g[0], setIsTogglingElementState = _g[1];
    var _h = react_1.useState(null), toggleError = _h[0], setToggleError = _h[1];
    var _j = use_metrics_property_management_1.useMetricsPropertyManagement({
        isOwnerManagementOpen: isOwnerManagementOpen,
        elementType: elementType,
        propertyId: property.id,
        propertyUseCases: propertyUseCases,
        selectedOwnerIds: selectedOwnerIds,
        stagedOwnerIds: stagedOwnerIds,
        stagedStatus: stagedStatus,
        canEditOwner: canEditOwner,
        canEditStatus: canEditStatus,
        shouldShowStatusField: shouldShowStatusField,
        initialStatus: initialStatus,
        onStageManagement: onStageManagement,
    }), draftOwnerIds = _j.draftOwnerIds, draftStatusByUseCaseId = _j.draftStatusByUseCaseId, isLoadingStatuses = _j.isLoadingStatuses, isSavingManagement = _j.isSavingManagement, managementError = _j.managementError, canSaveManagement = _j.canSaveManagement, handleOwnerSelectionChange = _j.handleOwnerSelectionChange, handleStatusChange = _j.handleStatusChange, handleSaveManagement = _j.handleSaveManagement, handleCancelManagement = _j.handleCancelManagement;
    var effectiveOwnerIds = isOwnerManagementOpen ? draftOwnerIds : selectedOwnerIds;
    var selectedOwnerNames = ownerOptions
        .filter(function (option) { return effectiveOwnerIds.includes(option.key); })
        .map(function (option) { return option.text; })
        .filter(function (text) { return typeof text === 'string'; });
    var ownerLabel = selectedOwnerNames.length === 0
        ? 'unassigned'
        : selectedOwnerNames.length === 1
            ? selectedOwnerNames[0]
            : selectedOwnerNames.length + " owners";
    react_1.useEffect(function () {
        var _a;
        setIsElementActive((_a = property.isEnabled) !== null && _a !== void 0 ? _a : true);
    }, [property.id, property.isEnabled]);
    var handleToggleElementActive = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ok, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!property.id || isTogglingElementState) {
                        return [2 /*return*/];
                    }
                    setIsTogglingElementState(true);
                    setToggleError(null);
                    if (!isElementActive) return [3 /*break*/, 2];
                    return [4 /*yield*/, element_popup_service_1.softDeleteElement(property.id)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, element_popup_service_1.restoreElement(property.id)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    ok = _a;
                    if (!ok) {
                        setToggleError('Could not update element state. Try again.');
                        setIsTogglingElementState(false);
                        return [2 /*return*/];
                    }
                    setIsElementActive(function (current) { return !current; });
                    setIsTogglingElementState(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var className = 'ws-metrics-property-card' +
        (isSelected ? ' is-selected' : '') +
        (isChanged ? ' is-changed' : '') +
        (isExpanded ? ' is-expanded' : '');
    var selectedStatus = draftStatusByUseCaseId[property.id] || use_metrics_property_management_1.METRICS_STATUS_OPTIONS[0];
    return (react_1.default.createElement("div", { key: property.id, className: className, role: "button", tabIndex: 0, "aria-pressed": isSelected, "aria-expanded": canExpand ? isExpanded : undefined, onClick: function (event) {
            // Ignore clicks coming from the use-case pill / callout / the
            // expand chevron / the alias list so they can do their own
            // thing without also toggling selection.
            var target = event.target;
            if (target.closest('.ws-metrics-property-aside') ||
                target.closest('.ws-metrics-property-aliases') ||
                target.closest('.ws-metrics-property-management')) {
                return;
            }
            onToggleSelection(property.id);
        }, onKeyDown: function (event) {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                onToggleSelection(property.id);
            }
        } },
        react_1.default.createElement("div", { className: "ws-metrics-property-row" },
            react_1.default.createElement(office_ui_fabric_react_1.Checkbox, { checked: isSelected, onChange: function () { return onToggleSelection(property.id); }, ariaLabel: "Select " + property.name }),
            react_1.default.createElement("div", { className: "ws-metrics-property-main" },
                react_1.default.createElement("span", { className: "ws-metrics-property-name" + (isElementActive ? '' : ' is-inactive') },
                    property.isEnabled,
                    react_1.default.createElement(SearchHighlight_1.HighlightedText, { value: property.name, matcher: searchMatcher }))),
            react_1.default.createElement("div", { className: "ws-metrics-property-aside" },
                react_1.default.createElement("button", { type: "button", className: 'ws-metrics-property-expand ws-metrics-property-owner-trigger' + (isOwnerManagementOpen ? ' is-open' : ''), "aria-label": isOwnerManagementOpen
                        ? "Hide owner management for " + property.name
                        : "Manage owner for " + property.name, title: isOwnerManagementOpen ? 'Hide owner management' : 'Manage owner', "aria-expanded": isOwnerManagementOpen, onClick: function (event) {
                        event.stopPropagation();
                        if (isSavingManagement) {
                            return;
                        }
                        setIsOwnerManagementOpen(function (current) { return !current; });
                    } },
                    react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "ReminderGroup" }),
                    react_1.default.createElement("span", null, ownerLabel),
                    react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: isOwnerManagementOpen ? 'ChevronUp' : 'ChevronDown' })),
                react_1.default.createElement("button", { type: "button", className: "ws-metrics-usecase-pill", ref: pillRef, disabled: useCaseCount === 0, title: useCaseCount === 0
                        ? 'Not referenced in any use case'
                        : "Used in " + useCaseCount + " use case" + (useCaseCount === 1 ? '' : 's'), onClick: function () {
                        if (useCaseCount === 0) {
                            return;
                        }
                        onToggleUseCases(property.id);
                    } },
                    react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "ReminderGroup" }),
                    react_1.default.createElement("span", null,
                        "Used in ",
                        useCaseCount,
                        " use case",
                        useCaseCount === 1 ? '' : 's')),
                canExpand && (react_1.default.createElement("button", { type: "button", className: 'ws-metrics-property-expand' + (isExpanded ? ' is-open' : ''), "aria-label": isExpanded
                        ? "Hide merged variants for " + property.name
                        : "Show " + aliasCount + " merged variant" + (aliasCount === 1 ? '' : 's') + " for " + property.name, title: isExpanded
                        ? 'Hide merged variants'
                        : "Show " + aliasCount + " merged variant" + (aliasCount === 1 ? '' : 's'), "aria-expanded": isExpanded, onClick: function (event) {
                        event.stopPropagation();
                        setIsExpanded(function (current) { return !current; });
                    } },
                    react_1.default.createElement("span", { className: "ws-metrics-property-expand-count" }, aliasCount),
                    react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: isExpanded ? 'ChevronUp' : 'ChevronDown' }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("button", { type: "button", className: "ws-metrics-button " + (isElementActive ? 'ws-metrics-button--activate' : 'ws-metrics-button--deactivate'), disabled: isTogglingElementState, onClick: function (event) {
                            event.stopPropagation();
                            void handleToggleElementActive();
                        } }, isElementActive ? 'Deactivate Element' : 'Activate Element'),
                    toggleError ? (react_1.default.createElement("div", { style: { marginTop: 6, color: '#dc2626' } }, toggleError)) : null))),
        isOwnerManagementOpen && (react_1.default.createElement("div", { className: "ws-metrics-property-management", role: "region", "aria-label": shouldShowStatusField
                ? "Owner and status management for " + property.name
                : "Owner management for " + property.name },
            react_1.default.createElement("div", { className: "ws-metrics-property-management-grid" },
                react_1.default.createElement("div", { className: "ws-metrics-property-management-field" },
                    react_1.default.createElement("span", { className: "ws-metrics-property-management-label" }, "Owners"),
                    react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { ariaLabel: "Owners", multiSelect: true, selectedKeys: draftOwnerIds, options: ownerOptions, disabled: !canEditOwner || isSavingManagement, onChange: function (_event, option) {
                            if (!option) {
                                return;
                            }
                            handleOwnerSelectionChange(option.key, !!option.selected);
                        } })),
                shouldShowStatusField && (react_1.default.createElement("div", { className: "ws-metrics-property-management-field ws-metrics-property-management-field--status-list" },
                    react_1.default.createElement("span", { className: "ws-metrics-property-management-label" }, "Status"),
                    react_1.default.createElement("div", { className: "ws-metrics-property-management-status-row" },
                        react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { ariaLabel: "Status for " + property.name, selectedKey: selectedStatus, options: use_metrics_property_management_1.METRICS_STATUS_OPTIONS.map(function (status) { return ({ key: status, text: status }); }), disabled: !canEditStatus ||
                                isLoadingStatuses ||
                                isSavingManagement, onChange: function (_event, option) {
                                if (!option) {
                                    return;
                                }
                                handleStatusChange(property.id, option.key);
                            }, styles: { root: { minWidth: 150 } } }))))),
            react_1.default.createElement("div", { className: "ws-metrics-property-management-actions" },
                react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ws-metrics-property-management-cancel", iconProps: { iconName: 'Undo' }, text: "Discard", disabled: !canSaveManagement || isSavingManagement || isLoadingStatuses, onClick: function (event) {
                        event.stopPropagation();
                        handleCancelManagement();
                    } }),
                react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { text: isSavingManagement ? 'Saving...' : 'Save', disabled: !canSaveManagement || isSavingManagement || isLoadingStatuses, onClick: function (event) {
                        event.stopPropagation();
                        void handleSaveManagement();
                    } })),
            managementError ? (react_1.default.createElement("div", { className: "ws-metrics-property-management-error" }, managementError)) : null)),
        canExpand && isExpanded && (react_1.default.createElement("div", { className: "ws-metrics-property-aliases", role: "region", "aria-label": "Merged variants for " + property.name },
            react_1.default.createElement("div", { className: "ws-metrics-property-aliases-header" },
                "Merged variants (",
                aliasCount,
                ")"),
            react_1.default.createElement("ul", { className: "ws-metrics-property-aliases-list" }, aliases.map(function (alias) { return (react_1.default.createElement("li", { key: alias.text, className: "ws-metrics-property-alias-item" },
                react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "BranchMerge" }),
                react_1.default.createElement("span", { className: "ws-metrics-property-alias-text" },
                    react_1.default.createElement(SearchHighlight_1.HighlightedText, { value: alias.text, matcher: searchMatcher })),
                alias.useCases.length > 0 && (react_1.default.createElement("span", { className: "ws-metrics-property-alias-usecases", "aria-label": "Seen in " + alias.useCases.length + " use case" + (alias.useCases.length === 1 ? '' : 's') }, alias.useCases.map(function (useCase) {
                    // Render the numeric id prominently — that's
                    // what the rest of the system tracks use cases
                    // by — and append the title for human context.
                    // The title alone (e.g. a repo slug) often
                    // doesn't match anything the user recognises
                    // in the navigation surface.
                    var hasFriendlyTitle = useCase.title.length > 0 && useCase.title !== useCase.id;
                    var label = hasFriendlyTitle
                        ? "#" + useCase.id + " \u00B7 " + useCase.title
                        : "#" + useCase.id;
                    return (react_1.default.createElement("button", { key: useCase.id, type: "button", className: "ws-metrics-property-alias-usecase-chip", title: "Open use case #" + useCase.id + (hasFriendlyTitle ? " (" + useCase.title + ")" : ''), onClick: function (event) {
                            event.stopPropagation();
                            onOpenUseCase(useCase.id);
                        } },
                        react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "OpenInNewWindow" }),
                        react_1.default.createElement("span", null, label)));
                }))))); })))),
        isCalloutOpen && (react_1.default.createElement(MetricsUseCaseCallout_1.MetricsUseCaseCallout, { property: property, target: pillRef.current, onDismiss: onDismissUseCases, onOpenUseCase: onOpenUseCase }))));
};
